module.exports = __webpack_public_path__ + "img/youngwoman.333c5d62.png";